/**
 * PersonelKart.jsx — denetmen tarafı Kişi Listesi'nin kart satırı
 *
 * Görsel dil firma tarafındaki Personel Listesi'nin (pages/Firma/FirmaPersonelListPage.jsx) aynısı
 * ve parçaları da aynı: vesikalık · belge kareleri · sayaç yığını Components/Kisi/PersonelKartParcalari
 * ve Components/Projects/StandPills'ten gelir (backlog #124: bu dosya kartın DÖRDÜNCÜ yerel kopyasıydı,
 * kendi StatusTile/VDivider/BELGELER/sayaç/avatar'ı vardı — silindi). Farklar:
 *   · #531 (Deniz'in beyaz tahta çizimi): vesikalığın ÇERÇEVESİ ile "Kart Yazdır" düğmesi HER ZAMAN aynı renkte ve o renk KART KARARI:
 *     yeşil "Kart Alabilir" · sarı "Alanda Kart Alabilir" (KVKK ve KKD dışında her şart tamam, ikisi alanda yapılır) · kırmızı
 *     "Kart Alamaz" · karar hesaplanmadıysa nötr gri. Karar `kartKarariUc`tan (services/kartDurumuService) okunur; backend `kartDurumu`
 *     değeri ve `uygunsuzluklar[]` kodlarıyla türetilir. ⚠️ Karar `kartKararMeta`/`kartKarariUc`tan okunur, `cardEligible`dan ASLA — "Tüm kişiler"de
 *     (ve firması olmayan kişide) hesaplanmaz ve `false` "kart alamaz" demek değildir; oradan okumak herkesi kırmızı basardı.
 *     WAS (until #531): sol üst ribbon KART KARARINI gösteriyordu (#362: lacivert "Kart: Tam" / yeşil "Kart: Yeterli" / "Kart: Özel İzin",
 *     sarı ve kırmızı satır `kartKararMeta` etiketiyle), vesikalığın çerçevesi KİMLİK DOĞRULAMAYDI (yeşil · gri · kırmızı).
 *     Şimdi ribbon YALNIZCA verilmiş bir Özel İzni (`singlePermit`, backend: yalnızca fuarlı satırda gelir) gösterir, başka hiçbir durumda yok;
 *     kimlik doğrulama artık "Onaylama" grubunda ayrı bir kare (yeşil doğrulandı · gri doğrulanmadı · kırmızı reddedildi).
 *   · Belge kareleri 5 BAŞLIKLI GRUPTA, her karenin altında adı yazılı (#531): Onaylama (Kimlik · KVKK) · [firma adı + rol] ·
 *     Kişisel Evraklar (SGK · İSG · Sağlık) · Mesleki Belgeler (Meslek) · Firma Evrakları (Firma · İSG) · Diğer (KKD).
 *     Gruplar PersonelBelgeKareleri'nin `bolum` + `etiketli` prop'larıyla basılır (firma adı kişisel evrakların önüne girdiği için tek
 *     satır olmaz). WAS (until #531): KVKK | kişinin dördü | firmanın İKİ grubu | KKD tek satırda, başlıksız. Bir satır birden çok
 *     firmayı kapsayabilir ve gruplar firma başına; öndeki firma `onFirmaSec`le seçilir (süzgeçteki firma → EN YEŞİL firma: üç durumlu
 *     kart kararı, eşitlikte firma belgelerinin doluluğu, #399 → `firmalar[0]`), diğerleri "+N" rozetinin arkasında.
 *     Çerçeve ve "Kart Yazdır" aynı firmayı konuşur.
 *   · "Kart Yazdır" (#128, #278) vesikalığın altında; üst çubukta fuar seçiliyken HER satırda açık (her iki
 *     görünüm, kırmızı/sarı satır dahil): düğme kararı vermez, açtığı pencere kararı okur, engelleri bağlantılarla
 *     gösterir ve yalnızca basılabiliyorsa yazdırır. Fuar = üst çubuktaki fuar (`kartFuarId`), liste görünümünün değil.
 *   · Belge kareleri ve sayaçlar fuarlı da fuarsız ("Tüm kişiler") gelir (`belgeler=true`, backend #119).
 *   · Kareler ve sayaçlar YENİ SEKMEDE açılan bağlantılardır (#273, #283): kişinin kareleri ve sayaçları
 *     öndeki firmanın (`on`) kişi sayfasına (KVKK → Detaylar, diğerleri → Belgeler + belge), firma kareleri
 *     o firmanın Belgeler sayfasına. Hepsi AYNI `on` firmasından kurulur — Detaylar düğmesi, kareler ve
 *     Kart Yazdır başka firmaları konuşmasın. Firması (ya da firmanın fuarı) olmayan kişi de açılır (#292): kareler,
 *     sayaçlar ve Detaylar firmasız kişi sayfasına gider (/Management/Kisi/Personeller/{id}); firma kareleri yok.
 *     Yeni sekme router state'i taşımadığı için liste adresi `geri` olarak adreste gider (kisiBaglantilari).
 *     İstisna #531: "Kimlik" karesi vesikalık gibi Kimlik Doğrulama penceresini açar (`onKimlik`).
 *   · Girişi yasaklı kişide "Kart Yazdır" yerine tıklanamayan "YASAKLI" yazısı durur (#285); kırmızı
 *     "Girişi Yasaklı" rozeti adın altında kalır. "Diğer" grubundaki TEK KKD karesi (eski adı Yelek, #368; #374): rengi `kkd.durum`dan
 *     (uygun yeşil · uyarı sarı · eksik kırmızı · istenmiyor soluk gri), başlığı fuarın istediği maddeleri sayar. `kkd` hiç gelmezse
 *     (eski yanıt) `givenVest`e düşülür.
 *   · "Kart Yazdır"ın altında, kart bu fuarda basıldıysa küçük "Basıldı ×N · gg.aa.yy" yazısı (`kartBasim`, #359/#130);
 *     eski PHP basımlarında tarih yoktur → yalnızca sayı.
 *   · Ad (#354) "Detaylar" düğmesiyle AYNI yere giden bağlantıdır (gerçek href: Ctrl/orta tık yeni sekmede açar).
 *   · Vesikalıkta kişinin fotoğrafı görünür (#352, `useKisiFoto`; yalnızca `fotografVar` iken okunur).
 *   · Firma adının altında o firmadaki rol (#370): `firmalar[i].isveren` → "İşveren" ya da "Çalışan" yazısı. #531: rozetin RENGİ kişinin o firmadaki
 *     durumu (`firmaKatilimMeta`: sarı Eşlendi · yeşil Görevlendirildi · kırmızı firma reddetti · gri bu fuarda görevli değil), iki rol de aynı
 *     renkleri alır. WAS (until #531): İşveren mavi, Çalışan soluk gri (renk rolü söylüyordu).
 *   · Arama varsa `aramaFirmalari[]` (eşleşen firmalar) firma satırının altında gösterilir:
 *     başka fuardan gelen eşleşme (`buFuarda === false`) `firmalar[]`'da görünmez, etiketsiz satır
 *     yanlış eşleşme gibi durur.
 *   · Vesikalık kutusu Kimlik Doğrulama'yı açar (#131, `onKimlik`; başlık "Kimlik Doğrula / Foto Ekle", role="button",
 *     Enter/Boşluk çalışır). #352: sağdaki ikinci "Kimlik" düğmesi KALKTI (#131'in "düğme de durur" kararı geri alındı) —
 *     kutu artık fotoğrafı gösterdiği için tek ve yeterli giriş.
 *   · Meslek vesikalığın altında küçük gri yazı, firma ayrı bir sütunda (#136); meslek o sütundaki
 *     "Meslek" düğmesinden açılan popup'la düzenlenir (`onMeslek`, bkz. MeslekDuzenleModal). Satırdaki
 *     meslek YÜRÜRLÜKTEKİdir (işe alım, yoksa kişi kartı); hangisi olduğu başlıkta (`meslekKaynak`).
 *     Popup yalnızca (firma, fuar) çiftine yazar: fuar görünümünde listedeki fuar, "Tüm kişiler"de
 *     öndeki firmanın son fuarı; ikisi de yoksa (hiç görevlendirilmemiş kişi) düğme kapalı.
 *   · "Fuara Eşle" (#261) sağdaki düğme yığınında: kişiyi ÜST ÇUBUKTAKİ fuara eşleyen popup'ı açar (`onFuaraEsle`;
 *     popup kişinin firmalarını okuyup bu fuardaki durumlarını söyler, #477; WAS (until #477): satır fuara hiç bakmazdı). Girişi yasaklı
 *     kişide ve üst çubukta fuar yokken kapalı. Fuara Eşlenmiş görünümünde (`fuarId` var) kişi zaten fuardadır, düğmenin
 *     işi firmaya eşlemektir ve adı "Firmaya Eşle" olur (#401), başka bir firmayla zaten eşliyse "Başka Firmaya Eşle"; Tüm Kişiler'de
 *     "Fuara Eşle" kalır, kişi üst çubuk fuarında zaten eşliyse (`aktifFuardaGorevli`, backend #476) GRİ ama tıklanabilir (#477),
 *     ipucu firmaları durumuyla sayar. Reddedilmiş görevlendirme kişiyi "eşli" yapmaz: o satırda düğme yeşil kalır.
 *   · Firma sütunu: öndeki (işe alan) firma + "+N". #384: sigortalı firma kavramı kalktı (backend #383); #264'ün
 *     "firma yazısını sigortalı firma devralır / İşe alan:" satırı geri alındı.
 */
import React from "react";
import { useLocation } from "react-router-dom";
import { Card, CardBody, Row, Col, Button, Badge } from "reactstrap";
import { Eye, Phone, Ban, Briefcase, Printer, Link2, IdCard, UserPlus } from "lucide-react";
import { KIMLIK_DURUM } from "../../services/kisiAdminService";
import { ESLESME_DURUM } from "../../services/personelRosterService";
import { kartKarariUc, isverenYolu, ISVEREN_ETIKETI } from "../../services/kartDurumuService";
import { StatusTile, VDivider, statusBackground } from "../Projects/StandPills";
import {
  PersonelAvatar, PersonelAdBaglantisi, PersonelBelgeKareleri, PersonelSayacStack, OzelIzinRibbon, RolRozeti,
} from "./PersonelKartParcalari";
import { DigerFirmalarRozeti, firmaAdi, onFirmaSec } from "./PersonelFirmaBelgeParcalari";
import { meslekEtiketi, etiketsizSertifikalar } from "./meslekler";
import { firmaBelgeleriUrl, kisiSayfasiUrl } from "./kisiBaglantilari";
import useKisiFoto from "./useKisiFoto";
import { useTranslation } from "react-i18next";
import i18n, { currentLocaleTag } from "../../i18n";

// #531: "Kimlik" karesinin rengi = kimlik doğrulama (eski #362 çerçevesiyle aynı renkler). `color` bir rozet rengi adı
// (statusBackground): secondary → nötr gri.
const KIMLIK_KARE = {
  0: { color: "secondary", get label() { return i18n.t("components:personelKart.kimlikDogrulanmadi"); } },
  1: { color: "success", get label() { return i18n.t("components:personelKart.kimlikDogrulandi"); } },
  2: { color: "danger", get label() { return i18n.t("components:personelKart.kimlikReddedildi"); } },
  3: { color: "info", get label() { return i18n.t("components:personelKart.kimlikAlandaDogrulanacak"); } }, // #664
};

// WAS (until the Yabancı Katılımcı card redo, 2026-10-21): OzelIzinRibbon and RolRozeti were defined here; both moved to PersonelKartParcalari.jsx
// (the Yabancı Katılımcı card draws the same ribbon and role label).

/** Başlıklı belge grubu (#531): başlık karelerin üstünde ortalı, kareler altında. */
function BelgeGrubu({ baslik, children }) {
  return (
    <div className="d-flex flex-column align-items-center gap-1">
      <div className="text-muted fw-semibold text-nowrap" style={{ fontSize: "0.68rem", lineHeight: 1.1 }}>{baslik}</div>
      {children}
    </div>
  );
}

/** Kart basım bilgisi (#359/#130): küçük yazı + ipucu; basılmadıysa null. `sonBasim` "yyyy-MM-dd HH:mm:ss", PHP döneminde null. */
function basimBilgisi(kartBasim) {
  if (!kartBasim?.basildi) return null;
  const sayi = kartBasim.basimSayisi > 0 ? kartBasim.basimSayisi : null;
  const t = kartBasim.sonBasim ? new Date(String(kartBasim.sonBasim).replace(" ", "T")) : null;
  const tarih = t && !Number.isNaN(t.getTime()) ? t : null;
  return {
    yazi: [
      sayi ? i18n.t("components:personelKart.basildi", { sayi }) : i18n.t("components:personelKart.basildi2"),
      tarih ? tarih.toLocaleDateString(currentLocaleTag(), { day: "2-digit", month: "2-digit", year: "2-digit" }) : null,
    ].filter(Boolean).join(" · "),
    baslik: [
      sayi ? i18n.t("components:personelKart.buFuardaKezBasildi", { sayi }) : i18n.t("components:personelKart.buFuardaBasildi"),
      tarih
        ? i18n.t("components:personelKart.sonBasim", { v: tarih.toLocaleString(currentLocaleTag(), { dateStyle: "short", timeStyle: "short" }) })
        : i18n.t("components:personelKart.sonBasimTarihiKayitliDegil"),
    ].join(" · "),
  };
}

/** Aramada eşleşen firmalar: kısa ad varsa o, başka fuardan geleni "(başka fuar)" etiketli. */
function AramaFirmalari({ firmalar }) {
  const { t } = useTranslation("components");
  if (!firmalar?.length) return null;
  const goster = firmalar.slice(0, 3);
  return (
    <div className="d-flex align-items-center gap-1 flex-wrap mt-1">
      {goster.map((f) => (
        <Badge
          key={f.firmaId} color="warning-subtle" className="text-body fw-normal"
          title={f.firmaName || undefined}
        >
          {f.firmaShortname || f.firmaName || t("personelKart.firma", { firmaId: f.firmaId })}
          {f.buFuarda === false ? t("personelKart.baskaFuar") : ""}
        </Badge>
      ))}
      {firmalar.length > goster.length && (
        <span className="text-muted" style={{ fontSize: "0.7rem" }}>+{firmalar.length - goster.length}</span>
      )}
    </div>
  );
}

/**
 * @param firmaFiltreId  süzgeçte seçili firma (varsa karar ve kareler onun)
 * @param fuarId         listede seçili fuar (fuar görünümü); "Tüm Kişiler"de null
 * @param kartFuarId     Kart Yazdır'ın fuarı = üst çubuktaki fuar; yoksa düğme kapalı
 * @param onKartYazdir   verilmezse düğme hiç basılmaz
 * @param onPanelDavet   verilmezse "Panele davet et" (SMS ile geçici kişi paneli, #647) hiç basılmaz
 * @param onMeslek       verilmezse "Meslek" düğmesi hiç basılmaz
 * @param onFuaraEsle    verilmezse "Fuara Eşle" düğmesi hiç basılmaz (hedef fuar = `kartFuarId`)
 */
export default function PersonelKart({
  person, firmaFiltreId = null, fuarId = null, kartFuarId = null, onKimlik, onDetay, onKartYazdir, onMeslek, onFuaraEsle, onPanelDavet,
  soluk = false,
}) {
  const { t } = useTranslation("components");
  const location = useLocation();
  const firmalar = person.firmalar || [];
  const on = onFirmaSec(person, firmaFiltreId);
  const digerleri = firmalar.filter((f) => f !== on);
  const meslekFuarId = fuarId || on?.sonFuarId || null;

  // #273/#283: yeni sekme bağlantıları. Firmalı kişi sayfası firma + fuar ister (Detaylar düğmesiyle aynı koşul);
  // firması ya da fuarı olmayan kişi FİRMASIZ kişi sayfasına gider (#292). Firma sayfası yalnızca firma ister.
  // Liste adresi (süzgeç/sayfa dahil) "geri" için adreste gider.
  const geri = `${location.pathname}${location.search}`;
  const baglamli = Boolean(on && meslekFuarId);
  const kisiUrl = (ek) => kisiSayfasiUrl({
    firmaId: baglamli ? on.firmaId : null, personId: person.personId, fuarId: baglamli ? meslekFuarId : null,
    geri, geriEtiket: t("personelKart.kisiListesineDon"), ...ek,
  });
  const belgeHref = (docKey) => kisiUrl({ docKey });
  const firmaHref = on ? firmaBelgeleriUrl({ firmaId: on.firmaId, fuarId: meslekFuarId }) : undefined;
  const sayacHref = kisiUrl({ tab: "belgeler" });
  // WAS (until #466): the Meslek button was disabled without a firma or a fair ("kisiHicbirFirmadaGorevliDegil" / "firmaninKayitliBirFuariYok"),
  // because the meslek was written to the person's hire at a fair. Meslekler belong to the person now (backend #464): always editable.
  // Fuarsız ("Tüm kişiler") satırda uç yürürlükteki mesleği çözemez: `person.meslekName` yalnızca
  // kişi kartındakidir ve çoğunlukla boştur, işe alımdaki meslek ise `firmalar[i].meslekName`'dedir
  // (popup'ın yazdığı yer). Bu yüzden öndeki firmanın işe alım mesleğine düşülür.
  // #372: birden çok meslek varsa "Kaynakçı +1" — fuarlı satırda `meslekler[]`, Tüm Kişiler'de öndeki firmanın işe alım
  // meslekleri; ipucu hepsini sayar. Tek meslekte eski davranış.
  const meslek = meslekEtiketi(person, on);
  const meslekAdi = meslek?.ad ?? null;
  // WAS (until #466): the title of a single meslek named its source ("kişi kartı" / the hire at a firma); the meslek is the person's now,
  // so the title lists the names and the card says who added each one.
  const meslekBasligi = meslek ? meslek.adlar.join(", ") : "";
  const durum = KIMLIK_DURUM[person.kimlikDogrulama?.durum] ? person.kimlikDogrulama.durum : 0;
  const foto = useKisiFoto(person.personId, person.fotografVar, person.logo);
  const basim = basimBilgisi(person.kartBasim);
  const kimlikKare = KIMLIK_KARE[durum];

  // #531: ÜÇ durumlu karar. Karar önce öndeki firmanın girdisinden (çerçeve, kareler ve Kart Yazdır aynı firmayı konuşur; firma süzgeci
  // açıkken o firma), girdi karar taşımıyorsa satırdan okunur. Özel İzin ve KKD satır düzeyindedir.
  const ozelIzin = person.singlePermit || null;
  const karar = kartKarariUc(on?.kartDurumu ? on : person, { ozelIzin, kkd: person.kkd });
  const kararHex = statusBackground(karar.color);
  const kararBaslik = [
    karar.hesaplandi && on ? `${karar.label} — ${firmaAdi(on)}` : karar.label,
    karar.hesaplandi && isverenYolu(person) ? ISVEREN_ETIKETI : null,
    karar.key === "ALANDA_KART_ALABILIR" ? t("personelKart.kararAlanda") : null,
    karar.key === "KART_ALAMAZ" ? t("personelKart.kararKartAlamaz") : null,
  ].filter(Boolean).join(" · ");
  const cerceve = { color: karar.color, label: kararBaslik };

  // Basılabilirlik kararını pencere verir (kart-karari + POST'un kendi kapısı, #127); burada yalnızca fuar şart.
  const yazdirEngeli = !kartFuarId ? t("personelKart.kartBasmakIcinUstCubuktan") : null;
  // Backend yasaklı kişiyi firma listesine de almaz (400); kimlik sorgusu akışı da orada durur.
  const esleEngeli = person.forbidden
    ? t("personelKart.girisiYasakliFuaraEslenemez")
    : !kartFuarId ? t("personelKart.eslemekIcinUstCubuktanBir") : null;
  // #477 (backend #476): kişi üst çubuk fuarında zaten eşli mi. `aktifFuardaGorevli` reddedilmiş görevlendirmeyi saymaz (o kişide düğme
  // yeşil kalır); alan yoksa (eski yanıt, firma listesi) hiçbir şey değişmez. İpucu firmaları durumuyla sayar: `firmalar[].aktifFuarda`
  // + `aktifFuarEslesmeDurumu` (0 Bekliyor, 1 Onaylandı, 2 Reddedildi, null kaydı yok).
  const fuardaEsli = person.aktifFuardaGorevli === true;
  const fuardakiFirmalar = firmalar.filter((f) => f.aktifFuarda).map((f) => {
    const durum = f.aktifFuarEslesmeDurumu != null ? ESLESME_DURUM[f.aktifFuarEslesmeDurumu]?.label : null;
    return durum ? `${firmaAdi(f)} (${durum})` : firmaAdi(f);
  }).join(", ");
  // Fuara Eşlenmiş görünümünde kişi zaten fuardadır: düğmenin işi firmaya eşlemek (#401), başka firmayla eşliyse "Başka Firmaya Eşle".
  // Tüm Kişiler'de eşli kişide düğme GRİ ama tıklanabilir kalır (#477): aynı kişi ikinci kez eşlenebilir, yalnızca haberi olsun.
  const baskaFirma = Boolean(fuarId) && fuardaEsli;
  const esleGri = !fuarId && fuardaEsli;
  const esleAciklama = fuarId ? t("personelKart.kisiyiUstCubuktakiFuardaBir") : t("personelKart.kisiyiUstCubuktakiFuaraEsle");
  const esleBaslik = esleEngeli
    || (fuardaEsli && fuardakiFirmalar ? `${t("personelKart.buFuardaZatenEsli", { firmalar: fuardakiFirmalar })}\n${esleAciklama}` : esleAciklama);

  // PersonelBelgeKareleri'nin ortak prop'ları; kareler `bolum` ile gruplara bölünüp başlıklarıyla ayrı ayrı yerleştirilir.
  const kareler = {
    documents: person.documents,
    gerekliBelgeler: person.gerekliBelgeler,
    kvkkDijitalOnay: person.kvkkDijitalOnay,
    firmaBelgeGruplari: on ? on.belgeGruplari ?? [] : undefined,
    firmaEki: digerleri.length > 0 ? (
      <DigerFirmalarRozeti
        personId={person.personId} firmalar={digerleri}
        hrefOf={(f) => firmaBelgeleriUrl({ firmaId: f.firmaId, fuarId: fuarId || f.sonFuarId })}
      />
    ) : undefined,
    hrefOf: belgeHref,
    firmaHref,
    kkd: person.kkd,
    yelek: { verildi: Boolean(person.givenVest) },
    meslekiEgitimler: person.meslekiEgitimler,
    etiketsizBelgeler: etiketsizSertifikalar(person).length,
    personId: person.personId,
    etiketli: true,
  };
  const ayrac = <VDivider className="d-none d-md-block" />;

  return (
    <Card className="mb-3 position-relative overflow-hidden" style={soluk ? { opacity: 0.5 } : undefined}>
      {ozelIzin && <OzelIzinRibbon izin={ozelIzin} />}
      <CardBody className={ozelIzin ? "pt-4" : undefined}>
        <Row className="align-items-center g-3">
          <Col md="auto">
            {/* mt-2: ribbon varsa çerçevenin rengini örtmesin. */}
            <div className={`d-flex flex-column align-items-center gap-2${ozelIzin ? " mt-2" : ""}`}>
              <PersonelAvatar photo={foto} cerceve={cerceve} onClick={onKimlik} aciklama={t("personelKart.kimlikDogrulaFotoEkle")} />
              {meslekAdi && (
                <div
                  className="text-muted text-center text-break" title={meslekBasligi}
                  style={{ fontSize: "0.7rem", maxWidth: 100, lineHeight: 1.2 }}
                >
                  {meslekAdi}{meslek.ek > 0 && <span className="fw-semibold"> +{meslek.ek}</span>}
                </div>
              )}
              {person.forbidden ? (
                // #285: yasaklı kişiye kart basılmaz (Özel İzin de kaldırmaz) — düğme yerine tıklanamayan yazı.
                <Badge
                  color="danger" className="text-nowrap" title={t("personelKart.girisiYasakliKartBasilamaz")}
                  style={{ fontSize: "0.7rem", padding: "5px 14px", letterSpacing: "0.06em" }}
                >
                  {t("personelKart.yasakli")}
                </Badge>
              ) : onKartYazdir && (
                <span title={yazdirEngeli || kararBaslik}>
                  {/* #531: düğme rengi = çerçeve rengi = kart kararı. Hex, çünkü bu temada `secondary` yeşilimsi, `success` gri basılıyor. */}
                  <Button
                    color="light" outline size="sm" className="text-nowrap"
                    style={{ fontSize: "0.7rem", padding: "1px 7px", color: kararHex, borderColor: kararHex, borderWidth: 2 }}
                    disabled={Boolean(yazdirEngeli)} onClick={onKartYazdir}
                  >
                    <Printer size={12} className="me-1" />{t("personelKart.kartYazdir")}
                  </Button>
                </span>
              )}
              {onPanelDavet && !person.forbidden && (
                <Button color="link" size="sm" className="p-0 text-nowrap text-muted" style={{ fontSize: "0.7rem" }} data-testid="kart-panel-davet" onClick={onPanelDavet}>
                  <UserPlus size={11} className="me-1" />{t("personelKart.panelDavet")}
                </Button>
              )}
              {basim && (
                <div
                  className="text-muted d-flex align-items-center gap-1 text-nowrap" title={basim.baslik}
                  style={{ fontSize: "0.65rem", lineHeight: 1 }}
                >
                  <Printer size={10} />{basim.yazi}
                </div>
              )}
            </div>
          </Col>

          <Col md="auto" style={{ minWidth: 170, maxWidth: 240 }}>
            <div className="fw-bold fs-5">
              <PersonelAdBaglantisi href={kisiUrl({})} onGit={onDetay}>{person.name} {person.surname}</PersonelAdBaglantisi>
            </div>
            <div className="text-muted small">{person.tcNo || person.tcNoMasked || "—"}</div>
            {person.phone && (
              <div className="text-muted d-flex align-items-center gap-1" style={{ fontSize: "0.75rem" }}>
                <Phone size={11} />{t("personelKart.iletisim", { phone: person.phone })}
              </div>
            )}
            {person.forbidden && (
              <div className="mt-1">
                <Badge color="danger" className="d-inline-flex align-items-center gap-1">
                  <Ban size={11} />{t("personelKart.girisiYasakli")}
                </Badge>
              </div>
            )}
          </Col>

          <Col className="d-flex flex-wrap align-items-center gap-3">
            <BelgeGrubu baslik={t("personelKart.baslikOnaylama")}>
              <div className="d-flex align-items-start gap-2">
                {/* #531: Kimlik karesi vesikalık gibi Kimlik Doğrulama penceresini açar. */}
                <StatusTile
                  icon={IdCard} background={statusBackground(kimlikKare.color)} label={kimlikKare.label}
                  caption={t("personelKart.kimlik")} onClick={onKimlik}
                />
                <PersonelBelgeKareleri {...kareler} bolum="kvkk" />
              </div>
            </BelgeGrubu>

            {/* #531: firma adı + rol. Rol yazısının rengi kişinin firmadaki durumu (Eşlendi sarı / Görevlendirildi yeşil). */}
            <div style={{ minWidth: 120, maxWidth: 180 }}>
              {on ? (
                <div title={firmalar.map(firmaAdi).join(", ")}>
                  <div className="fw-semibold text-break" style={{ fontSize: "0.95rem" }}>
                    {firmaAdi(on)}
                    {digerleri.length > 0 && <span className="text-muted fw-normal"> +{digerleri.length}</span>}
                  </div>
                  <RolRozeti firma={on} />
                </div>
              ) : (
                <div className="text-muted small">{t("personelKart.firmaYok")}</div>
              )}
              <AramaFirmalari firmalar={person.aramaFirmalari} />
              {onMeslek && (
                <span title={t("personelKart.meslegiDuzenle")} className="d-inline-block mt-2">
                  <Button
                    color="light" size="sm" className="border"
                    onClick={() => onMeslek({ firma: on, fuarId: meslekFuarId })}
                  >
                    <Briefcase size={12} className="me-1" />{t("personelKart.meslek")}
                  </Button>
                </span>
              )}
            </div>

            <BelgeGrubu baslik={t("personelKart.baslikKisisel")}>
              <PersonelBelgeKareleri {...kareler} bolum="kisisel" />
            </BelgeGrubu>
            {ayrac}
            <BelgeGrubu baslik={t("personelKart.baslikMesleki")}>
              <PersonelBelgeKareleri {...kareler} bolum="mesleki" />
            </BelgeGrubu>
            {on && (on.belgeGruplari ?? []).length > 0 && (
              <>
                {ayrac}
                <BelgeGrubu baslik={t("personelKart.baslikFirma")}>
                  <PersonelBelgeKareleri {...kareler} bolum="firma" />
                </BelgeGrubu>
              </>
            )}
            {ayrac}
            <BelgeGrubu baslik={t("personelKart.diger")}>
              <PersonelBelgeKareleri {...kareler} bolum="diger" />
            </BelgeGrubu>
          </Col>

          <Col md="auto" className="d-flex align-items-center gap-3 ms-auto mt-2 mt-md-0">
            <PersonelSayacStack counts={person.statusCounts} href={sayacHref} />
            <div className="d-flex flex-column gap-1">
              {onDetay && (
                <Button color="info" outline size="sm" onClick={onDetay}>
                  <Eye size={14} className="me-1" />{t("personelKart.detaylar")}
                </Button>
              )}
              {onFuaraEsle && (
                // Fuara Eşlenmiş görünümünde (fuarId var) kişi zaten fuardadır: düğmenin işi firmaya eşlemek. Tüm Kişiler'de fuara eşler.
                <span title={esleBaslik} className="d-grid">
                  <Button color={esleGri ? "gray" : "green"} size="sm" disabled={Boolean(esleEngeli)} onClick={onFuaraEsle}>
                    <Link2 size={14} className="me-1" />
                    {fuarId ? t(baskaFirma ? "personelKart.baskaFirmayaEsle" : "personelKart.firmayaEsle") : t("personelKart.fuaraEsle")}
                  </Button>
                </span>
              )}
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
